var map = {
	"./OurATS.png": "bea6",
	"./docs.png": "28e4",
	"./fuli.png": "f171",
	"./gitlab.png": "5b7b",
	"./google_translate.png": "cd12",
	"./harbor.png": "a9b2",
	"./kpi.png": "0ef0",
	"./luntan.png": "08ee",
	"./map.png": "21a8",
	"./oa.png": "d380",
	"./pm.png": "3a56",
	"./pom.png": "9987",
	"./qrcode.png": "5493",
	"./seafile.png": "a583",
	"./shangbiaotuijian.png": "32bd",
	"./xmqjt.png": "3a40"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf0c";